import { useLayout } from '@/providers'
import { Box, Stack } from '@mui/material'
import { Outlet } from 'react-router-dom'

import AnnouncementBanner from './AnnouncementBanner/AnnouncementBanner'
import AppBar from './AppBar/AppBar'
import Environment from './Environment'
import Sidebar from './SidebarOld'

const styles = {
	container: {
		overFlow: 'hidden',
		height: '100vh',
		marginTop: '0',
		display: 'flex',
		width: '100%',
		backgroundColor: (theme) => theme.palette.background.default,
	},
}

/**
 * Root level layout component
 */
export default function LayoutOld() {
	const { appBarHeight, announcementHeight } = useLayout()
	const totalTopOffset = `calc(${appBarHeight} + ${announcementHeight})`

	return (
		<Box sx={styles.container}>
			<AnnouncementBanner />
			<AppBar />
			<Sidebar />
			<Environment />
			<Stack
				sx={{
					marginTop: totalTopOffset,
					maxHeight: `calc(100% - ${totalTopOffset})`,
					overflow: 'auto',
					width: '100%',
					backgroundColor: 'background.default',
				}}
			>
				<Box overflow="auto">
					<Outlet />
				</Box>
			</Stack>
		</Box>
	)
}
